// extracted by mini-css-extract-plugin
export var activeDot = "_4i-c";
export var buttonContainer = "_4i-9";
export var channelButton = "_4i-a";
export var content = "_4i-0";
export var contentFull = "_4i-2";
export var contentThird = "_4i-1";
export var contentWrapper = "_4i-7";
export var description = "_4i-5";
export var heightShort = "_4i-e";
export var image = "_4i-3";
export var imageContainer = "_4i-4";
export var selectButton = "_4i-d";
export var spinnerContainer = "_4i-b";
export var titleContent = "_4i-8";
export var titleWrapper = "_4i-6";